import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, PhoneCall } from 'lucide-react';
import { useContact } from '../../context/ContactContext';
import SpotlightButton from '../ui/SpotlightButton';

export default function CTABanner({ title, subtitle, btnText }) {
  const { openModal } = useContact();

  return (
    <section className="w-full bg-background py-20 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="bg-gradient-to-r from-orange-600 to-orange-800 rounded-[3rem] p-10 md:p-20 flex flex-col lg:flex-row items-center justify-between gap-6 md:gap-12 shadow-2xl shadow-orange-600/20"
        >
          <div className="text-center lg:text-left max-w-2xl">
            <h2 className="text-2xl md:text-5xl font-black text-white tracking-tighter leading-tight mb-4 md:mb-6">
              {title || "Pronto para escalar sua empresa?"}
            </h2>
            <p className="text-orange-100 text-sm md:text-lg font-medium leading-relaxed opacity-80 mb-6 lg:mb-0">
              {subtitle || "Fale com nossos especialistas agora e descubra como a JWCosta pode transformar sua gestão."}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto px-4 sm:px-0">
            <a 
              href="https://wa.me/5511949830659"
              rel="noopener noreferrer"
              className="flex-1 lg:flex-none w-full sm:w-[240px] px-10 py-4 bg-white text-orange-600 font-black rounded-full transition-all duration-300 hover:scale-105 uppercase tracking-widest text-[10px] flex items-center justify-center gap-2 shadow-xl whitespace-nowrap"
            >
              Falar com Especialista
              <ArrowRight size={18} />
            </a>
            <SpotlightButton href="tel:1137514422" className="flex-1 lg:flex-none w-full sm:w-[240px]">
              <div className="flex items-center gap-2">
                <PhoneCall size={18} />
                (11) 3751-4422
              </div>
            </SpotlightButton>
          </div>
        </motion.div>
      </div>
      
      {/* Abstract Background Element */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] opacity-10 pointer-events-none">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff10_1px,transparent_1px),linear-gradient(to_bottom,#ffffff10_1px,transparent_1px)] bg-[size:40px_40px]"></div>
      </div>
    </section>
  );
}
